import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Link, Redirect } from 'react-router-dom';
import { ROUTING_CONFIG, supportArticleRoute, supportCategoryRoute } from '@uplift/constants';
import { Button } from '@uplift/ui-v2';
import { MainLayout } from '../../components';
import { getSupportArticleBySlug, getSupportCategory } from './articles';
import { useSupportArticleStyles } from './articles/article-shared';

export const SupportArticlePage = () => {
  const { slug } = supportArticleRoute.useParams();
  const article = getSupportArticleBySlug(slug);
  const { classes } = useSupportArticleStyles();

  if (!article) {
    return <Redirect to={ROUTING_CONFIG.support} />;
  }

  const ArticleContent = article.Component;
  const category = getSupportCategory(article.category);

  return (
    <MainLayout>
      <Container className={classes.content}>
        <Button
          component={Link}
          to={category ? supportCategoryRoute.createLink({ category: category.category }) : ROUTING_CONFIG.support}
          color="secondary"
          startIcon={<ArrowBack />}
          sx={{ mb: 2, px: 0 }}
        >
          {category ? `Back to ${category.label}` : 'Back to Help Center'}
        </Button>
        <Typography variant="h3" component="h1" gutterBottom>
          {article.title}
        </Typography>
        <Box mt={2}>
          <ArticleContent />
        </Box>
      </Container>
    </MainLayout>
  );
};
